import { reactive } from 'vue';

export const sharedState = reactive({ lrrRef: '' });

